module.exports = __webpack_public_path__ + "img/eye_close.ec816e26.svg";